import service from '@/request/service';

// 获取统一标段选项卡
export function getBidSectionBriefList(params) {
  return service({
    url: '/bidsection/getBidSectionBriefList',
    method: 'post',
    data: params
  });
}

// 获取互动咨询-系统公告 是否可以发消息
export function checkSendMsg(params) {
  return service({
    url: '/logMsg/checkSendMsg',
    method: 'get',
    params:params
  });
}

// 获取直播间信息
export function queryStudioLocationList(data) {
  return service({
    url: '/studio/queryStudioLocationList',
    method: 'post',
    data
  });
}

// 更新直播间信息
export function updateStudioLocationStage(data) {
  return service({
    url: '/studio/updateStudioLocationStage',
    method: 'post',
    data
  });
}

